module.exports = __webpack_public_path__ + "static/media/icon-bom.cee906fa.svg";